<template>
  <div>
    <el-tabs v-model="activeTab" @tab-change="handleChange" class=" tabs tabs__specifications" type="card">
      <el-tab-pane v-for="spec in specifications" :key="spec.id" :label="spec.title" :name="`tab-${spec.id}`">
        <product-specification-table :specification="spec"></product-specification-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProductSpecificationTable from './ProductSpecificationTable.vue';

export default {
  name: 'ProductSpecifications',
  props: {
    specifications: {
      type: Array,
      validator: validateSpecProp
    },
  },
  data() {
    return {
      activeTab: this.specifications && this.specifications.length > 0 ? `tab-${this.specifications[0].id}` : '',
    }
  },
  watch: {
    specifications(newSpecs, oldSpecs) {
      this.activeTab = newSpecs && newSpecs.length > 0 ? `tab-${newSpecs[0].id}` : '';
    },
  },
  methods: {
    handleChange(tab) {
      this.activeTab = tab;
    }
  },
  components: {
    'product-specification-table': ProductSpecificationTable
  }
}

//////////

function validateSpecProp(value) {
  let pass = true;

  value.forEach((item) => {
    if (typeof item !== 'object') {
      pass = false;
    }
  });

  return pass;
}
</script>

<style lang="scss" scoped>
.tabs {

  &__specifications {

    &.el-tabs__header {}

    &.el-tabs {

      &__header {
        margin: 0;
        border-bottom: 1px solid red !important;
      }

      &__nav {
        border-radius: 0 !important;
        border: none !important;
      }

      &__item {
        width: 240px;
        text-align: center;
        border-left: none !important;
        border-bottom: none !important;

        &.is-active {
          color: red;
          border-top: 1px solid red !important;
          border-left: 1px solid red !important;
          border-right: 1px solid red !important;
        }
      }
    }
  }
}
</style>
